import React from 'react';

type Props = {
    children: React.ReactNode
}

function DescriptionDetails(props: Props) {
    return (
        <dd className="mt-1 text-sm text-gray-900">
            {props.children}
        </dd>
    );
}

export default DescriptionDetails;